<template>
  <form id="detailInfoModal">
    <b-modal
      v-model="show"
      :title="$t('common.preview')"
      modal-class="spdo-modal preview"
      hide-header-close
      hide-footer
      centered
      size="lg"
      @hide="hideModal"
    >
      <div class="v-application spdo-modal__body pt-4 break-word">
        <div class="news-detail">
          <div class="news-detail__title">
            {{ news.subject }}
          </div>
          <div class="news-detail__lead">
            {{ news.lead }}
          </div>
          <div
            v-if="news.subject"
            class="news-detail__date"
          >
            {{ (news.startDate || new Date) | moment('L') }}
          </div>
          <img
            v-if="news.image"
            class="news-detail__image"
            :src="news.image.filePath"
          >
          <div
            class="news-detail__content"
            v-html="news.content"
          />
        </div>
      </div>
      <div class="v-application d-flex mt-4 sticky-bottom">
        <v-btn
          color="primary"
          class="mr-4 flex-grow-1"
          outlined
          large
          @click="hideModal"
        >
          {{ $t('common.close') }}
        </v-btn>
      </div>
    </b-modal>
  </form>
</template>

<script>

export default {
  name: 'PreviewModal',
  props: {
    value: Boolean,
    news: Object,
  },
  data: () => ({
    show: false,
  }),
  watch: {
    value(val) {
      this.show = val;
    },
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
    },
  },
};
</script>

<style lang="scss">
.preview {
  .spdo-modal__body {
    width: 900px;
  }

  .news-detail {
    width: 900px;
  }
}
// .break-word {
//   overflow-wrap: break-word;
// }
</style>
